import { makeBetterEnum } from '@watershed/constants/betterEnum';

import type { SemanticTemplateFieldName } from '../biV2/semanticSchemas/SemanticSchema';
import type { FootprintSnapshotSemanticSchema } from '../biV2/semanticSchemas/schemas/footprint';

/** Primitive fields map directly to attributes of the footprint */
export const FilterFieldLegacy = makeBetterEnum(
  'businessCategory',
  'businessSubcategory',
  'location',
  'locationCountry',
  'vendor',
  'product',
  'footprintKind',
  'ghgScope',
  'ghgCategoryId',
  'buildingName',
  'electricityType',
  'description'
);

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type FilterFieldLegacy =
  (typeof FilterFieldLegacy)[keyof typeof FilterFieldLegacy];

/**
 * These fields map directly to known attributes of the footprint in the new
 * Measurement Artifacts Interface, in contrast with fields custom to customers.
 * Listed in the same order as the fields in FilterField (but with the new
 * names), with the exception of productMarket - that has been removed.
 */
export const FilterFieldWatershed = makeBetterEnum(
  'categoryId',
  'subcategoryId',
  'location',
  'locationCountry',
  'locationState',
  'locationCity',
  'buildingName',
  'vendor',
  'rawVendor',
  'product',
  'footprintKind',
  'ghgScope',
  'ghgCategoryId',
  'companyId',
  'electricityType',
  'description',
  'inputUnit',
  'isSupplierSpecific'
);

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type FilterFieldWatershed =
  (typeof FilterFieldWatershed)[keyof typeof FilterFieldWatershed];

const internalFields = [
  'internalCategoryId',
  'internalSubcategoryId',
  'internalDescription',
  'internalGhgCategoryId',
  'internalLocationCountry',
  'internalLocationState',
  'internalLocationCity',
  'internalBuildingName',
  'internalProduct',
  'internalRawVendor',
] as const satisfies Array<
  SemanticTemplateFieldName<typeof FootprintSnapshotSemanticSchema>
>;
export const InternalFieldWatershed = makeBetterEnum(...internalFields);

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type InternalFieldWatershed =
  (typeof InternalFieldWatershed)[keyof typeof InternalFieldWatershed];
